<script>
  export let shop
</script>

{shop.title} orders
